"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterSortGroup = void 0;
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
var SactionState_init_1 = require("@/pages/search/states/SactionState.init");
exports.defaultSfilterSortGroup = {
    name: 'Sort',
    key: SfilterKey_1.SfilterKey.SORT,
    options: SactionState_init_1.defaultSactionSortOptions,
    selected: 0,
    opened: false,
};
